import styled from 'styled-components';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';

export const StyledRouterLink = styled(StyledVersionedRouterLink)`
  overflow-wrap: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const SingleRouterLink = styled(StyledVersionedRouterLink)`
  display: flex;
  flex-direction: row;
  gap: 10px;
  line-height: 32px;
  align-items: center;
  white-space: nowrap;
`;

// TODO: simplify and use flex w. gap, once we drop
// the Box component which doesn't support it.
// Replacing Box or updating styled-system
// could fix the issue, but is likely to introduce regressions.
// FYI Box does support a gridGap prop, but both are deprecated.
export const Separator = styled.div`
  margin-inline-end: 10px;
`;

export const LinkContainer = styled.div`
  display: flex;
  margin-inline-end: 10px;

  &:last-child {
    min-width: 0;
  }
`;
